<div class="">

    <!-- Modal content -->
    <div class="modal-content modulecss CroperImages ">

        <div class="modal-body pl-4 pr-4"> 
            <image-cropper format="png" [transform]="transform" [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="maintainAspectRatio" [cropperMinWidth]="cropperMinWidth" [cropperMinHeight]="cropperMinHeight" [aspectRatio]="aspectRatio" [resizeToWidth]="resizeWidth" [roundCropper]="roundCropper" (imageCropped)="imageCropped($event)"   class="{{imageSetwidth? 'fullWidthcrop' :'' }}"></image-cropper>
                <!--  [roundCropper]="roundCropper"  --> 
                <div class="loader"><i class="fa fa-spinner fa-spin" *ngIf="loader"></i></div>
            <div class="form-element md_footer congrats_btn w-100 mt-2">
                <div class="modal-footer buttons" > 
                         <a href="javascript:void(0)"  class="addMoreBtn orangeBtn me-3" (click)="Confirm()">Confirm</a>
                        <a href="javascript:void(0)" class="addMoreBtn greyBtn m-0 "  (click)="close()">Cancel</a>
                </div>
            </div>
        </div>
    </div>